import { createBrowserRouter } from "react-router-dom";
import App from "./App";
import Home from "./pages/Home";
import Stay from "./pages/Stay";
import Reservation from "./pages/Reservation";

const Router = createBrowserRouter([
	{
		path: "/",
		element: <App />,
		children: [
			{ path: "", element: <Home /> },
			{ path: "stay", element: <Stay /> },
			{ path: "reservation", element: <Reservation /> },
		],
	}
]);

export default Router;